var ProductAdditional = /*@__PURE__*/ (function () {
    function ProductAdditional(data) {
        if (data) {
            if (data.campagne) {
                this.campagne = data.campagne;
            }
            if (data.campagneColor) {
                this.campagneColor = data.campagneColor;
            }
            if (data.manufacturer) {
                this.manufacturer = data.manufacturer;
            }
            if (data.articleInCont) {
                this.articleInCont = data.articleInCont === 'true';
            }
            if (data.articleInStock) {
                this.articleInStock = data.articleInStock === 'true';
            }
            if (data.articleLocked) {
                this.articleLocked = data.articleLocked === 'true';
            }
            if (data.artnr) {
                this.artnr = parseInt(data.artnr, 10);
            }
            if (data.classification) {
                this.classification = data.classification;
            }
            if (data.deliveryTime) {
                this.deliveryTime = data.deliveryTime;
            }
            if (data.deviantOptions) {
                this.deviantOptions = parseInt(data.deviantOptions, 10);
            }
            if (data.deviceType) {
                this.deviceType = data.deviceType;
            }
            if (data.discWiSub) {
                this.discWiSub = data.discWiSub === 'true';
            }
            if (data.discWoSub) {
                this.discWoSub = data.discWoSub === 'true';
            }
            if (data.fkp) {
                this.fkp = data.fkp === 'true';
            }
            if (data.imageLarge) {
                this.imageLarge = data.imageLarge;
            }
            if (data.imageSmall) {
                this.imageSmall = data.imageSmall;
            }
            if (data.imageThumb) {
                this.imageThumb = data.imageThumb;
            }
            if (data.os) {
                this.os = data.os;
            }
            if (data.premiumCharge) {
                this.premiumCharge = data.premiumCharge;
            }
            if (data.shortDescription) {
                this.shortDescription = data.shortDescription;
            }
            if (data.simType) {
                this.simType = data.simType;
            }
            if (data.subsidizedWith) {
                this.subsidizedWith = data.subsidizedWith;
            }
            if (data.voiceEnabled) {
                this.voiceEnabled = data.voiceEnabled === 'true';
            }
            if (data.comments) {
                this.comments = data.comments;
            }
            if (data.networkType) {
                this.networkType = data.networkType;
            }
        }
    }
    return ProductAdditional;
}());
export { ProductAdditional };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/product/product.additional.ts
// module id = null
// module chunks = 